import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fide-chess2019',
  templateUrl: './fide-chess2019.component.html',
  styleUrls: ['./fide-chess2019.component.scss']
})
export class FideChess2019Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
